import { render, staticRenderFns } from "./ConsumptionBy.vue?vue&type=template&id=90a2974e&scoped=true"
import script from "./ConsumptionBy.vue?vue&type=script&lang=js"
export * from "./ConsumptionBy.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionBy.vue?vue&type=style&index=0&id=90a2974e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a2974e",
  null
  
)

export default component.exports